export const TASK_TITLE_MAX_LENGTH: number = 255;
export const TASK_TITLE_ILLEGAL_CHARS: string[] = ['<', '>', '/', '\\', ';'];
export const CANCELLATION_REASON_MAX_LENGTH: number = 255;
export const TASKS_PER_PAGE_MIN_VALUE = 1;
export const TASKS_PER_PAGE_MAX_VALUE = 100;
